<template>
  <teleport to="body">
    <modal-base :show="showModal" :title="$t('alojamiento.ubicacion')" hide-submit hide-cancel @on-close="close">
      <template #body>
        <GMapMap
          v-if="latitud && longitud"
          :center="mapPosition"
          :zoom="8"
          map-type-id="terrain"
          style="min-height: 60vh">
          <GMapMarker :position="mapPosition" :clickable="true" :draggable="false">
            <GMapInfoWindow
              opened
              :options="{
                pixelOffset: {
                  width: 10,
                  height: 0,
                },
                maxWidth: 320,
                maxHeight: 320,
              }">
              <div class="bold">
                {{ nombre }}
              </div>
            </GMapInfoWindow>
          </GMapMarker>
        </GMapMap>
      </template>
    </modal-base>
  </teleport>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import ModalBase from '@/components/modales/ModalBase.vue';

  const props = defineProps({
    latitud: {
      type: [String, Number],
      required: true,
    },
    longitud: {
      type: [String, Number],
      required: true,
    },
    nombre: {
      type: String,
      required: false,
      default: '',
    },
  });

  const showModal = ref(false);

  const mapPosition = computed(() => {
    return {
      lat: parseFloat(props.latitud),
      lng: parseFloat(props.longitud),
    };
  });

  function show() {
    showModal.value = true;
  }

  function close() {
    showModal.value = false;
  }

  defineExpose({
    show,
  });
</script>

<style lang="scss" scoped>
  :deep(.gm-ui-hover-effect) {
    display: none !important;
  }
</style>
